<template>
    <div id="systemUserAdd">

        <el-card class="search-form-card">

            <el-form :inline="true" :model="form" @keyup.enter.prevent="request">
                <el-form-item>
                    <el-input v-model="form.keyword" placeholder="请输入关键字" @keyup.enter.native="request"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="request" type="primary">搜索</el-button>
                </el-form-item>
            </el-form>

        </el-card>

        <el-card>

            <el-table :data="tableData" v-loading='loading' border @selection-change='selectclick'>

                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-for='item of pageSizes' :key='item' v-if="form.pageSize===item">
                            {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*item : scope.$index+1}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column type="selection" width="55"></el-table-column>

                <el-table-column label="用户名" prop="internalUserid"></el-table-column>

                <el-table-column label="真实姓名" prop="name"></el-table-column>

                <el-table-column label="所在部门" prop="department.name"></el-table-column>

            </el-table>

            <!-- 分页器 -->
            <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="form.pageIndex"
             :page-sizes="[10,20, 30, 40]"
             :page-size="form.pageSize"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
            </el-pagination>

            <div class='footer'>
                <el-button type="primary" @click='submit'>确定</el-button>
                <el-button type="primary" @click='onCancel'>取消</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import services from './system.services'
export default {
    props: {
        id: Number,
        type: String,
        callback: Function
    },
    data() {
        return {
            tableData: [],
            total: 0,
            form: {
                keyword: '',
                pageIndex: 1,
                pageSize: 10
            },
            loading: true,
            pageSizes: [10, 20, 30, 40],
            oBox:null,
            oParent:null,
        }
    },
    mounted() {
        this.changeDialogWidth()
        this.request()
    },
    methods: {
        changeDialogWidth(){
            this.oBox=document.getElementById('systemUserAdd')
            this.oParent=this.oBox.offsetParent
            // console.log(this.oParent);
            this.oParent.style.width='80%'
        },
        request(val) {
            services.userList(this.form)
                .then(res => {
                    this.tableData = res.list
                    this.total = res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.pageSize = val;
            if(this.form.pageIndex > pages ){
                this.form.pageIndex  = 1;
            };
            this.request();
        },
        handleCurrentChange(val){
            this.form.pageIndex = val;
            this.request();
        },
        selectclick(selection){
            this.selection = selection
        },

        submit() {
            let params ={
                internalUserid: this.selection.map(item => item.internalUserid)
            }
            if (this.type === 'group') {
                params = { ...params, groupId: this.id + '', }
                this.addRequest(services.updateGroup, params)
            } else {
                params = { ...params, departmentId: this.id + '', }
                this.addRequest(services.updateDepartment, params)
            }
        },
        addRequest(request, params) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            request(params)
                .then(res => {
                    this.$message.success('成功')
                    this.close(true)
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => {
                    this.$emit('closePopOut', false)
                    loading.close()
                    this.callback()
                })
        },
        onCancel(){
            this.close();
        },
        close(refresh) {
            this.$modal.close();
            refresh && refresh === true ? this.callback() : '';
        }

    }
}
</script>

<style>
    /*#systemUserAdd{*/
    /*    width: 75%;*/
    /*}*/
    .footer {
        margin: 20px 0;
    }
</style>
